import { ACTION_IDS } from "../actionIds";

/**
 * Sticky header for easyAccessOperator (userType = 6): Správa lístkov + Logout.
 */
export function getHeaderActions(context) {
  const { isLoggedIn } = context;

  return [
    {
      id: ACTION_IDS.ACCESS_SYSTEM_TICKETS,
      visible: isLoggedIn,
      tooltipKey: "sidebar.menuItem.accessSystemTickets",
      tooltipDefault: "Správa lístkov",
      ariaLabelKey: "sidebar.menuItem.accessSystemTickets",
      ariaLabelDefault: "Správa lístkov",
      iconId: "accessSystemTickets",
    },
    {
      id: ACTION_IDS.LOGOUT,
      visible: isLoggedIn,
      tooltip: "Logout",
      ariaLabel: "Logout",
      iconId: "logout",
    },
  ];
}
